import type { NgZone } from '@angular/core';
import type { Nullable } from '@sibe/utilities/common';
import { MonoTypeOperatorFunction, Observable, Subscriber, Subscription } from 'rxjs';

export function subscribeOutsideAngular<T>(ngZone: NgZone): MonoTypeOperatorFunction<T> {
  return (source$: Observable<T>) =>
    new Observable<T>((subscriber: Subscriber<T>) => {
      let subscription: Nullable<Subscription> = null;

      ngZone.runOutsideAngular(() => {
        subscription = source$.subscribe(subscriber);
      });

      return { unsubscribe: () => subscription?.unsubscribe() };
    });
}
